import { render, staticRenderFns } from "./ColorQuantitySelector.vue?vue&type=template&id=49d616ee&scoped=true"
import script from "./ColorQuantitySelector.vue?vue&type=script&lang=ts"
export * from "./ColorQuantitySelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d616ee",
  null
  
)

export default component.exports